import React from 'react'
import {useLocation} from 'react-router-dom'
import {LoginForm, CompleteNewPasswordForm} from 'components/organisms/login'
import ForgotPasswordPage from 'components/pages/login/ForgotPasswordPage'
import Auth from 'lib/auth'
import {useAuthentication} from '../providers/AuthenticationProvider'

function LoginPage() {
  const {user} = useAuthentication()
  const location = useLocation()

  if (location.hash === '#/forgot-password') {
    return <ForgotPasswordPage />
  }
  return Auth.newPasswordRequired(user) ? (
    <CompleteNewPasswordForm />
  ) : (
    <LoginForm />
  )
}

export default LoginPage
